<div class="like-label" *ngIf="game.launchUrl">
  <button class="btn btn-primary rounded-circle d-flex justify-content-center p-2" type="button"
          title="{{'HOME.FAVOURITES' | translate}}" (click)="setFavourites(game.id)">
    <app-svg-icon class="variable-svg-icon" [pathIdentifier]="favouriteGameIds.includes(game.id) ? 'favourites_filled' : 'favourites'"></app-svg-icon>
  </button>
</div>
